import { COURSE, CourseActionType } from './course.actions';
import { Course } from '../../@types/course.interface';

interface IState {
    courses: Course[];
}

const INITIAL_STATE: IState = {
    courses: [],
};

export default function courseReducer(
    state: IState = INITIAL_STATE,
    action: CourseActionType
): IState {
    switch (action.type) {
        case COURSE:
            return {
                ...state,
                courses: action.payload.courses,
            };
        default:
            return state;
    }
}
